import type { Template } from "@/types";

export const SQ_02_H0_V2: Template[] = [
    {
        id: "sq-02-h0v2-01",
        name: "SQ 01 - H0V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h0_v2_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 374, y: 104, width: 340, height: 510, rotation: 0, imageRotation: 0 },
            { id: "2", x: 722, y: 104, width: 339, height: 510, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "sq-02-h0v2-02",
        name: "SQ 02 - H0V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h0_v2_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 234, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 722, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "sq-02-h0v2-03",
        name: "SQ 03 - H0V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h0_v2_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 120, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 838, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "sq-02-h0v2-04",
        name: "SQ 04 - H0V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h0_v2_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 223, y: 155, width: 271, height: 407, rotation: 0, imageRotation: 0 },
            { id: "2", x: 836, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "sq-02-h0v2-05",
        name: "SQ 05 - H0V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h0_v2_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 313, y: 59, width: 401, height: 600, rotation: 0, imageRotation: 0 },
            { id: "2", x: 722, y: 59, width: 400, height: 600, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "sq-02-h0v2-06",
        name: "SQ 06 - H0V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h0_v2_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 153, y: 51, width: 411, height: 616, rotation: 0, imageRotation: 0 },
            { id: "2", x: 940, y: 156, width: 271, height: 407, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "sq-02-h0v2-07",
        name: "SQ 07 - H0V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h0_v2_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 61, y: 60, width: 400, height: 600, rotation: 0, imageRotation: 0 },
            { id: "2", x: 972, y: 60, width: 400, height: 600, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-02-h0v2-08",
        name: "SQ 08 - H0V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h0_v2_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 119, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 940, y: 155, width: 271, height: 407, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "sq-02-h0v2-09",
        name: "SQ 09 - H0V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h0_v2_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 560, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 881, y: 67, width: 390, height: 584, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "sq-02-h0v2-10",
        name: "SQ 10 - H0V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h0_v2_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 164, y: 67, width: 390, height: 584, rotation: 0, imageRotation: 0 },
            { id: "2", x: 880, y: 0, width: 560, height: 717, rotation: 0, imageRotation: 0 }
        ],
    },
    


];
